import { render } from "./nav.vue?vue&type=template&id=1f80e7d4"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"

import "./nav.vue?vue&type=style&index=0&id=1f80e7d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__